import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalStatus extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			status:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);
		
	}

	handleShow(item){
		this.setState({
			status: item,
			show:true
		})
	}

	handleClose(){
		this.setState({
			show: false,
			status:[],
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Historico de Estatus</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<Table responsive hover>
		        				<thead>
				                  	<tr>
				                  		<th>Estatus</th>
					                    <th>Fecha</th>
					                    <th>Hora</th>
				                  	</tr>
				                </thead>
				                <tbody>
				                 	{this.state.status
									 .sort((a, b) => moment(a.timestamp_date) - moment(b.timestamp_date))
									.map( (s, index) => (
				                    	//index !== this.state.status.length - 1 ?
				                    		<tr key={index}>
					                    		<td>{s.status}</td>
					                      		<td>{moment(s.timestamp_date).format('DD/MM/YYYY')}</td>
							                    <td>{moment(s.timestamp_hour, 'H:mm:ss').format('HH:mm')}</td>
					                    	</tr>
					                    //: null
				                  	))}
				                </tbody>
		        			</Table>

		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalStatus);